// export const specialCategory = {
//   key: "special",
//   title: "burger",
//   color: "#ff9110",
//   startDate: "25-12-2021",
//   days: 7,
//   endDate: "2 Jan "22",
//   description:
//     "Have you tasted a burger 🍔 before? Tell us about your favourite burger. 😃",
//   homepage_description: `<div class="px-2 p-sm-2">
//   Welcome to Burger week. What is your favorite burger!?
//   </div>`,
// };

export const SpecialCategory = {
  key: "current_feeling",
  title: "current feeling",
  color: "#6903DB",
  startDate: "",
  days: 7,
  endDate: "",
  description:
    "Have you tasted a burger 🍔 before? Tell us about your favourite burger. 😃",
  homepage_description:
    `<div class="p-2"> Local time: ` +
    new Date().toLocaleTimeString([], {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    }) +
    `</div>`,
};

export const CategoryColors = [
  "#6903DB", // current feeling
  "#FFEF0A", // happy
  "#1C5A8F", // sad
  "#FE0089", // surprise
  "#8F7A7A", // fear
  "#D12D00", // anger
  "#FF9110", // special
  "#808080", // other
];

export const Categories = [
  {
    title: "current feeling",
    key: "current_feeling",
  },
  {
    title: "happy",
    key: "happy",
  },
  {
    title: "sad",
    key: "sad",
  },
  {
    title: "surprise",
    key: "surprise",
  },
  {
    title: "fear",
    key: "fear",
  },
  {
    title: "anger",
    key: "angry",
  },
  {
    title: "other",
    key: "other",
  },
];

export const FeelingCategories = [
  {
    title: "current feeling",
    key: "current_feeling",
  },
  {
    title: "happy",
    key: "happy",
  },
  {
    title: "sad",
    key: "sad",
  },
  {
    title: "surprise",
    key: "surprise",
  },
  {
    title: "fear",
    key: "fear",
  },
  {
    title: "anger",
    key: "angry",
  },
  {
    title: "burger",
    key: "special",
  },
  {
    title: "other",
    key: "other",
  },
];

export const ActivityCategories = [
  {
    title: "Current activity",
    key: "current_activity",
  },
  {
    title: "Eating",
    key: "eating",
  },
  {
    title: "Playing",
    key: "playing",
  },
  {
    title: "Working",
    key: "working",
  },
  {
    title: "Reading",
    key: "reading",
  },
  {
    title: "Watching",
    key: "watching",
  },
  {
    title: "Other",
    key: "other",
  },
];

export const PostCategories = [
  {
    title: "Anxiety",
    key: "anxiety",
    id: 28,
  },
  {
    title: "Angry",
    key: "angry",
    id: 29,
  },
  {
    title: "Arts",
    key: "arts_design",
    id: 0,
  },
  {
    title: "Banking",
    key: "banking",
    id: 22,
  },
  {
    title: "Business",
    key: "business",
    id: 1,
  },
  {
    title: "Craziness",
    key: "craziness",
    id: 2,
  },
  {
    title: "Current feeling",
    key: "current_activity",
    id: 3,
  },
  {
    title: "Crush",
    key: "crush",
    id: 25,
  },
  {
    title: "Dance",
    key: "dance",
    id: 4,
  },
  {
    title: "Dreams",
    key: "dreams",
    id: 5,
  },
  {
    title: "Goals",
    key: "goals",
    id: 23,
  },
  {
    title: "Facts",
    key: "facts",
    id: 6,
  },
  {
    title: "Fashion & Lifestyle",
    key: "fashion_lifestyle",
    id: 7,
  },
  {
    title: "Favorite songs",
    key: "favorite_songs",
    id: 8,
  },
  {
    title: "Food habits",
    key: "food_habits",
    id: 9,
  },
  {
    title: "General",
    key: "general",
    id: 10,
  },
  {
    title: "Chit-chat",
    key: "chit_chat",
    id: 26,
  },
  {
    title: "Happy",
    key: "happy",
    id: 27,
  },
  {
    title: "Health & Fitness",
    key: "health_fitness",
    id: 20,
  },
  {
    title: "Ideas",
    key: "innovative_ideas",
    id: 11,
  },
  {
    title: "Medical",
    key: "medical",
    id: 19,
  },
  {
    title: "Music",
    key: "music",
    id: 12,
  },
  {
    title: "Motivation",
    key: "motivation",
    id: 13,
  },
  {
    title: "Places",
    key: "locations",
    id: 23,
  },
  {
    title: "Pet lovers",
    key: "pet_lovers",
    id: 14,
    hidden: true,
  },
  {
    title: "Thoughts",
    key: "random_thoughts",
    id: 15,
  },
  {
    title: "To Covid Warriors",
    key: "campaign_covid_warriors",
    id: 30,
  },
  {
    title: "To Students",
    key: "campaign_students",
    id: 31,
  },
  {
    title: "Opinions",
    key: "opinions",
    id: 24,
  },
  {
    title: "Sad",
    key: "sad",
    id: 27,
  },
  {
    title: "Shopping",
    key: "shopping",
    id: 21,
  },
  {
    title: "Spiritual",
    key: "spiritual",
    id: 16,
  },
  {
    title: "Sports",
    key: "sports",
    id: 17,
  },
  {
    title: "Writings",
    key: "writings",
    id: 18,
  },
];

export const InterestedCategories = [
  {
    label: "Arts & Design",
    value: "arts_design",
  },
  {
    label: "Business",
    value: "business",
  },
  {
    label: "Craziness",
    value: "craziness",
  },
  {
    label: "Current activities",
    value: "current_activity",
  },
  {
    label: "Dance",
    value: "dance",
  },
  {
    label: "Dreams/Goals",
    value: "dreams",
  },
  {
    label: "Facts",
    value: "facts",
  },
  {
    label: "Fashion & Lifestyle",
    value: "fashion_lifestyle",
  },
  {
    label: "Favorite songs",
    value: "favorite_songs",
  },
  {
    label: "Food habits",
    value: "food_habits",
  },
  {
    label: "General",
    value: "general",
  },
  {
    label: "Innovative ideas",
    value: "innovative_ideas",
  },
  {
    label: "Music",
    value: "music",
  },
  {
    label: "Motivation",
    value: "motivation",
  },
  {
    label: "Pet lovers",
    value: "pet_lovers",
  },
  {
    label: "Thoughts",
    value: "random_thoughts",
  },
  {
    label: "Sports",
    value: "sports",
  },
  {
    label: "Writings/Poetry",
    value: "writings",
  },
];

export const SimilarityCategories = [
  {
    id: "food_habits",
    text: "Food habits",
    value: 80,
  },
];

export const RangeCategories = [
  {
    id: "food_habits",
    text: "Food habits",
    value: 80,
  },
  {
    id: "outfit",
    text: "Outfit",
    value: 90,
  },
  {
    id: "face_coverings",
    text: "Face coverings",
    value: 80,
  },
  {
    id: "emotion_happy",
    text: "Happy Day",
    value: 70,
  },
];

export const ReferenceCategories = [
  {
    id: "temp.",
    ranges: [120, 15, 121, 0, 140],
    measures: [85],
    markers: [100],
  },
  {
    id: "power",
    ranges: [0.6324555773181647, 0.16420819778521298, 1.7099174201908238, 0, 2],
    measures: [0.762131162771875, 1.9278967958998887],
    markers: [1.7194518943235708],
  },
  {
    id: "volume",
    ranges: [33, 27, 3, 23, 32, 11, 0, 60],
    measures: [9],
    markers: [50],
  },
  {
    id: "cost",
    ranges: [98070, 284719, 113899, 0, 500000],
    measures: [370174, 375768],
    markers: [378800],
  },
  {
    id: "revenue",
    ranges: [7, 6, 6, 0, 13],
    measures: [10],
    markers: [12.445201051193276, 12.706166532136663],
  },
];
